export function objectIdHash(id: string): string {
  return id
    .split('')
    .reverse()
    .join('')
    .substring(0, 7)
    .split('')
    .reverse()
    .join('');
}

export function levenshteinDistance(a: string, b: string): number {
  if (a === b) return 0;
  if (a.length === 0) return b.length;
  if (b.length === 0) return a.length;

  if (a.length <= 2 && b.length <= 2) {
    return a === b ? 0 : 1;
  }

  let previousRow = Array(b.length + 1)
    .fill(0)
    .map((_, i) => i);

  let currentRow = new Array(b.length + 1);

  for (let i = 1; i <= a.length; i++) {
    currentRow[0] = i;

    for (let j = 1; j <= b.length; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      currentRow[j] = Math.min(
        currentRow[j - 1] + 1,
        previousRow[j] + 1,
        previousRow[j - 1] + cost,
      );
    }

    [previousRow, currentRow] = [currentRow, previousRow];
  }

  return previousRow[b.length];
}
